module.exports = require("babel-runtime/helpers/possibleConstructorReturn");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/possibleConstructorReturn"
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7